import styled from 'styled-components';

export const TableItemCell = styled.div`
    width: calc(33.33333% - 14px);
    border: 1px solid #999;
    margin: 0 20px 20px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px;
    transition: all .3s ease 0s, margin-right 0s linear 0s;
    position: relative;
    min-height: 116px;
    color: #fff;

    &.full {
        width: 100%;
        margin: 20px 0;
    }

    &.half {
        flex: 1;
        width: calc(50% - 10px);
        max-width: calc(50% - 10px);
        min-width: calc(50% - 10px);
    }

    &.noBorder {
        border-width: 0;
    }

    &.half:nth-child(2n),
    &:not(.half):nth-child(3n) {
        margin-right: 0;
    }

    :not(.noBorder) {
        cursor: pointer;
    }

    :not(.noBorder):hover {
        border: 1px solid ${props => props.theme.colors.main};
    }

    :not(.noBorder):hover .text {
        color: ${props => props.theme.colors.main};
    }
`;

export const TableItemOwner = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    height: 20px;
    width: 20px;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '\\F01A5';
        font-family: 'Material Design Icons';
        color: #f92;
        text-shadow: 1px 1px 0px #333, 1px -1px 0px #333, -1px -1px 0px #333, -1px 1px 0px #333;
        font-size: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: cebter;
    }
`;

export const TableItemName = styled.div`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    max-height: 50%;
    height: 50%;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: all .3s ease 0s;

    .full & {
        width: 95%;
        max-width: 95%;
    }
`;

export const TableItemLabel = styled.div`
    color: #999;
    font-size: 14px;
    height: 25%;
    max-height: 25%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const TableAccessLabel = styled.div`
    color: #999;
    font-size: 14px;
    flex: 1;
`;

export const TableImage = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 110px;
    z-index: 0;

    &:before {
        content: '\\F02EB';
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100px;
        background: #111;
        display: flex;
        font-size: 50px;
        color: #444;
        align-items: center;
        justify-content: center;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 80px;
        background: rgb(34,34,34);
        background: linear-gradient(270deg, rgba(34,34,34,0) 0%, rgba(34,34,34,1) 100%);
    }
`;

export const TableItemContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    padding: 20px;
    box-sizing: border-box;

    .half &,
    .full & {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: stretch;
    }
`;

export const TableItemInfo = styled.div`
    flex: 1;
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
`;


export const Empty = styled.div`
    color: #777;
    font-style: italic;
`;

